import React, { Suspense } from 'react';
import { CalendarsWidget } from '@benzinga/calendars';
import { ArticleData, getInitialTab, getInitialTickers } from '@benzinga/article-manager';
import { DateTime } from 'luxon';

export interface ArticleCalendarWidgetProps {
  article: ArticleData;
}

export const ArticleCalendarWidget: React.FC<ArticleCalendarWidgetProps> = ({ article }) => {
  const initialTab = getInitialTab(article);
  const initialTickers = getInitialTickers(article);

  if (!initialTab || !getInitialTickers(article)?.length) {
    return null;
  }

  const params = {
    dateFrom: DateTime.now().minus({ months: 3 }).toJSDate(),
    dateTo: DateTime.now().plus({ months: 1 }).toJSDate(),
  };

  return (
    <Suspense fallback={<div aria-hidden className="min-h-[200px] w-full" />}>
      <CalendarsWidget initialTab={initialTab} initialTickers={initialTickers} params={params} visibleTitle={false} />
    </Suspense>
  );
};

export default ArticleCalendarWidget;
